(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip/assets/javascripts/views/parts/rows-external-display.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip/assets/javascripts/views/parts/rows-external-display.js');
"use strict";

const {
  useContext
} = React;
const {
  useSelector
} = ReactRedux;
const {
  RowsDisplayView
} = svs.components.tipsen.betslip.views.parts;
const {
  BetslipContext
} = svs.components.tipsen.betslip;
const {
  boardType
} = svs.components.tipsen.engine.constants;
const RowsExternalDisplay = () => {
  const {
    couponId
  } = useContext(BetslipContext);
  const totalAmountOfRows = useSelector(state => state.Coupons[couponId].totalAmountOfRows);
  const isExternalMSYS = useSelector(state => {
    var _state$Coupons$coupon;
    return (_state$Coupons$coupon = state.Coupons[couponId]) === null || _state$Coupons$coupon === void 0 || (_state$Coupons$coupon = _state$Coupons$coupon.boards[0]) === null || _state$Coupons$coupon === void 0 ? void 0 : _state$Coupons$coupon.type;
  }) === boardType.BOARD_MULTIPLE;
  return React.createElement(RowsDisplayView, {
    isExternalMSYS: isExternalMSYS,
    numberOfRows: totalAmountOfRows
  });
};
setGlobal('svs.components.tipsen.betslip.views.parts.RowsExternalDisplay', RowsExternalDisplay);

 })(window);